<template >

    <sq-form v-loading="loading" style="height: calc(100vh - 128px)">
      <s-form-actions
          slot="header"
          class="clearfix" >
        <!-- <sr-ctk-dater
          style="width:100%"
          range
          slot="left"
          route-query-prop="timerange"
          xmodel="timelineRange"
          display-format="dd/MM/yyyy"
          export-format="DD/MM/YYYY"
        ></sr-ctk-dater>-->
        <h4
            class="sc-header"
            slot="left"
            v-if="Buisness" >
          <el-button
              icon="el-icon-close"
              type="text"
              @click="$router.push({name:'flattransview',params:{id:'all'}})" >
            <!--   <span class="material-icons">close</span> -->
          </el-button >
          {{ Buisness.name }}
          <small v-if="sums" >
            <el-tag type="warning" >Depts:{{ $theMoney(sums.total_depts) }}</el-tag >
            <el-tag type="success" >Payments:{{ $theMoney((sums.cash_pays || 0) + (sums.bank_pays || 0)) }}</el-tag >
          </small >
        </h4 >
        <span v-else >
          <small v-if="sums" >
            <el-tag type="warning" >Depts:{{ $theMoney(sums.total_depts) }}</el-tag >
            <el-tag type="success" >Payments:{{ $theMoney((sums.cash_pays || 0) + (sums.bank_pays || 0)) }}</el-tag >
          </small ></span >
        <template v-if="$refs.drafts" >
          <el-button
              style="float:right"
              type="success"
              round
              @click="$refs.drafts.appendRecord({businessId:$route.params.id,in:0,isincome:0})"
              :disabled="!Buisness||$refs.drafts.hasEmptyLine()"
              :title="$refs.drafts.hasEmptyLine()?'You already have an empty transaction, please fill it before adding a new one':'Add a new transaction'" >
            +
            <span class="material-icons" >receipt</span >
          </el-button >
        </template >
      </s-form-actions >
      <div >

        <s-table
            ref="drafts"
            rowKeyField="id"
            xheightWish="tobottomn"
            :pagging="50"
            v-model="relDrafts"
            xallwaysEdit="true"
            xedit-disabled="disabled"
            :colDefinitions="colDefinitions"
            modx-processor="transdrafts/vuegetlist"
            :r-query="qrelDrafts"
            :lazyLoader="true"
            :addEmptyLine="false"
            @cell-change="handleRelDraft"
            @cell-clicked="goTrans"
            @data-loaded="displaySums"
            :newRowData="{}" ></s-table >
      </div >
    </sq-form >

</template >
<script >
import _ from "lodash";
import * as api from "~/api/resource";
import commons from "~/mixins/commons";
import {mapActions, mapGetters} from "vuex";

export default {
  mixins: [commons],
  // name: "FlatDrafts",
  props: {
    // disabled: {
    //   type: Boolean,
    //   default: false
    // },
    invoiceData: {
      type: Object,
      default: () => {
      },
    },
    businessId: {
      default: null,
    },
  },
  data() {

    return {
      // bookingRange: null,
      sums: null,
      disabled: true,
      loaded: false,
      dialogVisible: false,
      updating: false,
      loading: false,
      relDrafts: [],
      relRoutes: [],
      newRow: null,
      parentDraftId: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // "$route.query": {
    //   async handler(val, oldval) {
    //     if (!val || val == oldval) return;
    //     this.loading = true;
    //     this.relRoutes = await api.getModxList("transdrafts/vuegetlist", {
    //     ...this.qrelDrafts,view:'sums'
    //     });
    //     this.loading = false;
    //   },
    //   immediate: true,
    //   depp:true
    // }
  },
  computed: {
    qrelDrafts() {
      const qPrts = {...this.$route.query}
      if (this.$route.params.tripid) {
        delete qPrts.timerange_from
        delete qPrts.timerange_to
      }
      return {
        active: true,
        transctx: "out",
        isbusiness: 0,
        mode: "full",
        tripid: this.$route.params.tripid,
        businessId:
            this.$route.params.id != "all" ? this.$route.params.id : null,
        view: "acc_flat",
        timeBy: 'Route.date',
        focus: null,
        exacttag: null,
        ...qPrts,
        // rangeApplyOnTime: true,
        // rangeApplyOnAlert: false
      };
    },

    colDefinitions() {
      const vm = this;
      // _log_(">>>>>", this.invoiceData);

      let o = [


        {
          prop: "route_date_in",
          width: "110px",
          editable: false,
          label: "Check In.",
          placeholder: "...",
          formatter: vm.dateFromUnxTime
        },
        {
          prop: "route_date_out",
          width: "110px",
          editable: false,
          label: "Check Out.",
          placeholder: "...",
          formatter: vm.dateFromUnxTime
        },
        {
          prop: "pax",
          width: "70px",
          editable: false,
          label: "PAX",
          placeholder: "...",
        },
        {
          prop: "title",
          xwidth: "200px",
          editable: true,
          label: "Write a comment",
          placeholder: "...",
        },

        {
          label: "Dept amount",
          prop: "deptamound",
          editorcomponent: {
            placeholder: "Dept amount",
            formatgreek: false,
            is: "s-number",
          },
          width: "150px",

          editable: true,

          formatter(val, colDefs, row) {
            if (val !== null)
              return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          prop: "bank_payedamound",
          editorcomponent: {
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",
          editable: true,
          label: "Bank P.",
          formatter(val, colDefs, row) {
            if (val !== null)
              return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "cash_payedamound",
          editorcomponent: {
            formatgreek: false,
            is: "s-number",
          },
          width: "120px",
          editable: true,
          label: "Cash P.",
          formatter(val, colDefs, row) {
            if (val !== null)
              return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          prop: "balance", width: "130px", editable: false, label: "Your Dept", formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },

        {
          prop: "transactionId",
          width: "60px",
          label: "X",
          viewcomponent: {
            is: "el-button",
            type: "danger",

            icon: "el-icon-delete",
          },
          // clickable: true,
          formatter(val, colDefs, row) {
            return "X";
          },
        },
      ];
      if (!this.$route.params.id || this.$route.params.id == 'all') o = [{
        prop: "serviseName",
        maxWidth: "200px",
        editable: false,
        label: "Supplier",
        placeholder: "...",
        formatter: function (val, colDefs, row, vm) {
          // _log_(">>>> serviseName " + val, row);
          return val ? val : row["name-afm"];
        },
      },
        ...o]
      if (!this.$route.params.tripid) o = [{
        prop: "packageName",
        width: "200px",
        editable: false,
        label: "Package",
        placeholder: "...",
        alterClickable: true,
        formatter(val) {
          return val
              ? val
              : '<span class="material-icons" title="this is not related to package">payments</span>';
        },
        link(val, colDefs, row, vm) {
          return row.package_id
              ? "/spa/#/tripsmanager/package/tripadmin/" +
              row.package_id +
              "/tripacctransactions"
              : null;
        },
      },
        // {
        //   prop: "package_date",
        //   width: "110px",
        //   editable: false,
        //   label: "Pack.Date",
        //   placeholder: "...",
        //   formatter: function (val, colDefs, row, vm) {
        //     // _log_(">>>>" + val, row);
        //     return vm.formatDate(val);
        //   },
        // },
        ...o]
      return o;
    },
    ...mapGetters({
      transactionConfiguration: "user/transactionConfiguration",
    }),
  },
  mounted() {
    this.loaded = true;

    // this.$nextTick(() => {
    //   this.$refs.drafts.appendTrackedData([{}]);
    // });
    // _log_("trans.ss.REMOUNT ii..", this.qrelDrafts);
  },
  methods: {
    displaySums(e) {
      if (e)
        this.sums = e.sums
      _log_("SUMS.ss.REMOUNT ii..", e);
    },
    init() {
    },
    async goTrans(e) {
      if (e.column.property == "transactionId") {
        if (!e.row.id) {
          return;
        }
        if (e.row.package_id) {
          this.$message("you cannot delete that.");
          return;
        }
        const {data} = await api.fetchProcessor(
            "transdrafts/multidelete",
            e.row
        );
        this.$refs.drafts.reloadAll();
        this.$emit("updateBusiness", e.row);
        // this.routeGo({
        //   name: "transaction",
        //   params: {
        //     transid: e.row.id,
        //     id: e.row.businessId,
        //     direction: "out",
        //     view: "contact",
        //   },
        // });
      }
    },
    async handleRelDraft(data) {
      // _log_("UPPPP..", data);
      // if (!this.TransDraft) return;
      var dr = data.row;
      dr.exectime = "now";
      dr.time = "now";
      // dr.businessId = this.TransDraft.businessId;
      // dr.isincome = this.TransDraft.isincome;

      // dr.parentid = this.$route.query.selectedTrans;
      // dr.in = this.$route.params.direction;
      // dr.place = this.TransDraft.place;
      // // dr.isicome = this.$route.params.direction == "in";
      // dr.type = "payment";
      //
      if (dr) {
        const isNew = !dr.id;
        const {data} = await api.fetchProcessor(
            "transdrafts/flat_update",
            dr
        );
        const drafts = data.results;
        _log_("UPPPP.handleRelDraft..." + dr.idx, data, dr);
        // if (isNew && this.$refs.drafts)
        if (drafts.bank)
          this.$refs.drafts.updateRow(
              {idx: dr.idx},
              {bank_draft_id: drafts.bank.id}
          );
        if (drafts.cash)
          this.$refs.drafts.updateRow(
              {idx: dr.idx},
              {cash_draft_id: drafts.cash.id}
          );
        if (drafts.dept)
          this.$refs.drafts.updateRow(
              {idx: dr.idx},
              {dept_draft_id: drafts.dept.id, id: drafts.dept.id}
          );
        this.$emit("updateBusiness", dr);
        // if (!isNew) this.$refs.drafts.updateRow(d);
        // else this.$refs.drafts.updateRow({ id: null }, d);
      }

      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // Transdraft = {};
    },
    handleClose(done) {
      _log_("trans..B..");
      this.disabled = true;
      this.TransDraft = null;
      this.$emit("refresh");
      if (!done) {
        this.dialogVisible = false;
        return;
      }
      done();
    },
    handleTransctions(e) {
      // _log_("trans..B..", e);
    },
  },
};
</script >


